import { render, staticRenderFns } from "./VpayAccount.vue?vue&type=template&id=6db21b54&scoped=true"
import script from "./VpayAccount.vue?vue&type=script&lang=js"
export * from "./VpayAccount.vue?vue&type=script&lang=js"
import style0 from "./VpayAccount.vue?vue&type=style&index=0&id=6db21b54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db21b54",
  null
  
)

export default component.exports